import config from "config/config";

export default {
  ul: {
    listStyle: "none",
  },
  li: {
    position: "relative",
    marginTop: "8px",
    marginBottom: "8px",
    paddingLeft: "40px",
    paddingTop: "8px",
  },
  "li:before": {
    content: `url("${config.staticUrl}/i/icons/checkmark-green.svg")`,
    position: "absolute",
    left: "10px",
  },
};
